import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Link } from "react-router-dom";
import { showNotificationDialogEmergencyOrder } from "redux/actions/notificationEmergencyOrderActions";
import {
  postFileAccess,
  showErrorMessageByCode,
} from "services/commonServices";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { useDispatch, useSelector } from "react-redux";
import { CreateManualPO } from "./ManualPoCreateSearch";
import { UploadManualPO } from "./ManualPoUpload";
import { PAGE, PO_ELEMENTS } from "components/common/CONSTANTS";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3, pl: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export const CreateUploadSupplierPO = () => {
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [isUploadAllowed, setUploadAllowed] = useState(false);
  const [isCreateAllowed, setCreateAllowed] = useState(false);

  const userType = useSelector((state) => state.user);
  const { accessiblePages } = userType.userType;

  const downloadTemplate = () => {
    const request = {
      apikey: SOMS_API_KEY,
      params: {
        fileName: "manualPurchaseOrderTemplate.csv",
        reportType: "template",
      },
    };

    postFileAccess(request)
      .then((response) => {
        const url = response.fileURL;
        const fileDownloadTag = document.createElement("a");
        fileDownloadTag.href = url;
        fileDownloadTag.click();
      })
      .catch((err) => {
        const { errTitle, errContent } = showErrorMessageByCode(err);
        dispatch(
          showNotificationDialogEmergencyOrder(errTitle, errContent, "Done")
        );
      });
  };

  useEffect(() => {
    setUploadAllowed(
      accessiblePages[PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.key].includes(
        PO_ELEMENTS.UPLOAD_PO.UPLOAD_TAB
      )
    );
    setCreateAllowed(
      accessiblePages[PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.key].includes(
        PO_ELEMENTS.CREATE_PO.CREATE_TAB
      )
    );
  }, [accessiblePages]);
  return (
    <>
      <div className="mainPageStyling">
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography component="h1" variant="h5" sx={{ mb: 2, mr: 2 }}>
            {PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.label}
          </Typography>
        </div>
        <Box sx={{ width: "100%", mt: 0.5, pl: 0 }} className="tabStyling">
          <Box
            sx={{ borderBottom: 2, borderColor: "primary", height: "1.76rem" }}
          >
            <Tabs
              className="tabPanelStyling"
              value={value}
              onChange={handleChange}
              aria-label="customer demand tabs"
              textColor="primary.contrastText"
              sx={{
                minHeight: "1rem",
                "& button": {
                  backgroundColor: "secondary.light",
                  fontWeight: "bold",
                  width: "10vw",
                  minHeight: "1.6rem",
                  p: ".3em 0",
                  fontSize: "0.7rem",
                },

                "& .Mui-selected": {
                  backgroundColor: "primary.main",
                  color: "white",
                },
              }}
            >
              {isUploadAllowed && <Tab label="Upload" {...a11yProps(0)} />}
              {isCreateAllowed && <Tab label="Create" {...a11yProps(1)} />}
              {value === 0 && (
                <>
                  <div className="downloadLink">
                    {" "}
                    <FileDownloadOutlinedIcon
                      onClick={downloadTemplate}
                      style={{
                        height: "18px",
                        color: "#108810",
                        cursor: "pointer",
                        position: "relative",
                        top: "5px",
                      }}
                    />
                    <span>
                      <Typography>
                        <Link
                          style={{
                            color: "#108810",
                            cursor: "pointer",
                            fontSize: "11px",
                          }}
                          onClick={downloadTemplate}
                        >
                          Download Template
                        </Link>
                      </Typography>
                    </span>
                  </div>
                </>
              )}
            </Tabs>
          </Box>

          <TabPanel
            value={value}
            index={0}
            component="div"
            className="uploadManualStyling"
          >
            <UploadManualPO />
          </TabPanel>
          <TabPanel value={value} index={1} component="div">
            <CreateManualPO />
          </TabPanel>
        </Box>
      </div>
    </>
  );
};
